import { MrfiktivFleetViewModelGen } from "@/services/mrfiktiv/v1/data-contracts";

/**
 * Interface for fleet tree node
 */
export interface FleetTreeNode {
  id: string;
  name: string;
  parentId?: string;
  children?: FleetTreeNode[];
}

/**
 * Converts a flat fleet list into a fleet tree structure
 * @param fleets
 * @returns
 */
export function buildFleetTree(fleets: MrfiktivFleetViewModelGen[]): FleetTreeNode[] {
  const idNodeMap = new Map<string, FleetTreeNode>();
  const tree: FleetTreeNode[] = [];

  fleets.forEach(f => {
    idNodeMap.set(f.id, {
      id: f.id,
      name: f.title,
      parentId: f.parentId,
      children: []
    });
  });

  idNodeMap.forEach(node => {
    if (node.parentId) {
      const parent = idNodeMap.get(node.parentId);
      if (parent && parent.children) {
        parent.children.push(node);
      }
    } else {
      tree.push(node);
    }
  });

  return tree;
}
